import React from 'react';

const DonateModal = ({ open, amount, onClose, onProceed }) => {
  if (!open) return null;

  return (
    <div className="ul-modal-backdrop" style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div className="ul-modal" role="dialog" aria-modal="true" style={{background:'#fff',borderRadius:12,width:'min(720px,96%)',padding:24}}>
        <button onClick={onClose} aria-label="Close" style={{float:'right',border:0,background:'transparent',fontSize:18}}>✕</button>
        <h3 style={{marginTop:0}}>Confirm Donation</h3>
        <p style={{marginBottom:8}}>Amount: <strong>${amount}</strong></p>
        <div style={{display:'grid',gap:12}}>
          <input id="donor-name" placeholder="Your name (optional)" style={{padding:10,border:'1px solid #ddd',borderRadius:6}} />
          <input id="donor-email" type="email" placeholder="Email (for receipt)" style={{padding:10,border:'1px solid #ddd',borderRadius:6}} />
          <div style={{display:'flex',gap:8}}>
            <button onClick={() => onProceed({amount})} className="ul-btn" style={{flex:1}}>Proceed to Payment (Simulated)</button>
            <button onClick={onClose} style={{flex:1,background:'#eee',border:0,padding:10,borderRadius:6}}>Cancel</button>
          </div>
          <small style={{color:'#666'}}>Note: This demo opens a simulated payment flow. To accept real payments, connect a backend or Stripe Payment Links.</small>
        </div>
      </div>
    </div>
  );
};

export default DonateModal;
